import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import SessionUtils from "@/utility/SessionUtils";
import portalContext from "@/context/contexts/portal-context";
import { getActiveShop } from "@/constants/utility";

const EmployeeRestrictedRoute = ({ flagKey, component: Component, children, ...rest }) => {
  const context = useContext(portalContext);
  const storemode = /true/.test(getActiveShop(context)?.storemode);
  const employee = storemode ? SessionUtils.getItem("rs_employee") : null;
  const isRestricted = employee?.[flagKey] === true;

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        isRestricted ? (
          <Redirect to="/" />
        ) : Component ? (
          <Component {...routeProps} />
        ) : (
          children
        )
      }
    />
  );
};

export default EmployeeRestrictedRoute;
